<template>
    <div class="alert-wrap" v-if="notifications.length > 0">
        <transition-group :name="transition" :appear="true" tag="div">
            <div :class="item.typeObject" role="alert" :key="index + 0" v-for="(item, index) in notifications">
                <span class="flash-icon" v-if="displayIcons" :class="item.iconObject"></span><span v-html="item.message"></span>
                <button v-if="item.isImportant" type="button" class="flash__close-button" data-dismiss="alert" aria-label="alertClose" @click.stop.prevent="hide(item)"><span aria-hidden="true">&times;</span></button>
            </div>
        </transition-group>
    </div>
</template>

<script>
    export default {
        props: {
            timeout: {
                type: Number,
                default: 60000
            },
            transition: {
                type: String,
                default: 'slide-fade'
            },
            types: {
                type: Object,
                default: () => ({
                    base:    'alert',
                    success: 'alert-success',
                    danger:  'alert-danger',
                    warning: 'alert-warning',
                    info:    'alert-info'
                })
            },
            displayIcons: {
                type: Boolean,
                default: false
            },
            icons: {
                type: Object,
                default: () => ({
                    base:    'fa',
                    success: 'fa-check-circle',
                    danger:  'fa-exclamation-circle',
                    warning: 'fa-exclamation-circle',
                    info:    'fa-info-circle',
                })
            },
        },
        data: () => ({
            notifications: []
        }),

        methods: {
            /**
             * Flash our alert to the screen for the user to see
             * and begin the process to hide it
             *
             * @param message
             * @param type
             * @param important
             */
            flash(message, type, important) {
                let notification = {
                    message: message,
                    type: type,
                    typeObject: this.classes(this.types, type),
                    iconObject: this.classes(this.icons, type),
                    isImportant: important
                };

                this.notifications.push(notification);

                if (important === false) {
                    setTimeout(() => {
                        this.hide(notification)
                    }, this.timeout);
                }
            },
            /**
             * Sets and returns the values needed
             *
             * @param propObject
             * @param type
             */
            classes(propObject, type) {
                let classes = {};

                if(propObject.hasOwnProperty('base')) {
                    classes[propObject.base] = true;
                }

                if (propObject.hasOwnProperty(type)) {
                    classes[propObject[type]] = true;
                }

                return classes;
            },
            /**
             * Hide Our Alert
             *
             * @param item
             */
            hide(item = this.notifications[0]) {
                let key = this.notifications.indexOf(item);
                this.notifications.splice(key, 1);
            }
        },
    }
</script>
<style scoped>
    /* stylelint-disable */
    .alert-wrap {
        position: fixed;
        right: 25px;
        top: 90px;
        z-index:9999;
        width: 30rem;
    }

    .flash-icon {
        margin-right: .7rem;
    }

    /**
        * Fade transition styles
        */
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
        opacity: 0
    }

    /**
        * Bounce transition styles
        */
    .bounce-enter-active {
        animation: bounce-in .5s;
    }
    .bounce-leave-active {
        animation: bounce-in .5s reverse;
    }
    @keyframes bounce-in {
        0% {
            transform: scale(0);
        }
        50% {
            transform: scale(1.5);
        }
        100% {
            transform: scale(1);
        }
    }

    /**
        * Slide transition styles
        */
    .slide-fade-enter-active {
        transition: all .3s ease;
    }
    .slide-fade-leave-active {
        transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for <2.1.8 */ {
        transform: translateX(10px);
        opacity: 0;
    }

    .flash__close-button {
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        position: absolute;
        top: 0;
        right: 0;
        color: inherit;
        -webkit-appearance: none;
        -moz-appearance: none;
        background-color: transparent;
        background: none;
        border: none;
        cursor: pointer;
        font-size: 18px;
        line-height: 10px;
        margin-left: 2rem;
        padding: 8px;
    }

    .flash__close-button:active,.flash__close-button:focus {
        outline: none;
    }
</style>